module.exports = __webpack_public_path__ + "img/ospical-logo.8beb45a5.png";